import { render, staticRenderFns } from "./SmallTitle.vue?vue&type=template&id=1e37bdcb&scoped=true&"
import script from "./SmallTitle.vue?vue&type=script&lang=js&"
export * from "./SmallTitle.vue?vue&type=script&lang=js&"
import style0 from "./SmallTitle.vue?vue&type=style&index=0&id=1e37bdcb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e37bdcb",
  null
  
)

export default component.exports